import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import {
  Button,
  Col,
  Form,
  Spinner
} from 'react-bootstrap'
import ModalBackdropForm from './common/modalBackdropForm'
import * as actions from '../actions'

class Login extends Component {

    state = {
      email: '',
      password: ''
    }

    componentDidMount () {
      this.props.setError()
    }

    _handleOnSubmit () {
      this.props.login(this.state)
    }

    _renderMessage () {
      const { auth: { error } } = this.props
      if (error) {
        return (
          <Col xs={12} className='mb-3 alert alert-danger'>
            {error}
          </Col>
        )
      }
      return (
        <Col xs={12} className='mb-3'>
          Sign in to Drivers Clearinghouse.
        </Col>
      )
    }

    _renderButtonContents () {
      const { auth: { loading } } = this.props

      if (loading) {
        return (
          <React.Fragment>
            <Spinner animation='border' size='sm' className='align-middle mr-2'></Spinner>
            Signing in
          </React.Fragment>
        )
      }
      return 'Sign in'
    }

    render () {
      const { auth: { loading } } = this.props
      return (
        <ModalBackdropForm
          onSubmit={() => this._handleOnSubmit()}
          displayHelpLink={true}
          displayForgotPasswordLink={true}
        >
          {this._renderMessage()}
          <Col xs={12}>
            <Form.Group>
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type='email'
                autoComplete='email'
                value={this.state.email}
                onChange={(e) => this.setState({ email: e.target.value })}
                required
              ></Form.Control>
            </Form.Group>
          </Col>
          <Col xs={12}>
            <Form.Group>
              <Form.Label>Password</Form.Label>
              <Form.Control
                type='password'
                autoComplete='current-password'
                onChange={(e) => this.setState({ password: e.target.value })}
                required
              ></Form.Control>
            </Form.Group>
          </Col>
          <Col xs={12} className='my-3'>
            <Button
              variant='primary'
              block
              type='submit'
              disabled={loading}
            >{this._renderButtonContents()}</Button>
          </Col>
        </ModalBackdropForm>
      )
    }
}

const mapStateToProps = (state) => {
  const { auth } = state
  return { auth }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    { ...actions.auth, ...actions.navigation },
    dispatch
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)

Login.propTypes = {
  auth: PropTypes.object.isRequired,
  login: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired
}